const ConfigApp = {
  accessToken: "accessToken",
  refreshToken: "refreshToken",
  basketModel: "basketTempModel",
  userInfo: "userInfo",
};

export default ConfigApp;
